import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {DeleteLine, EditLine, OpenLine} from '@dropbox/dig-icons/assets';
import type {ProductRoadmapEmbedConfigResponse} from 'client';
import {t} from 'i18next';
import {RoadmapDocumentEmbed} from 'views/productRoadmap/RoadmapDocumentEmbed';

export const WorkstreamRoadmapEmbed = ({
  data,
  disabled,
  onOpen,
  onEdit,
  onRemove,
}: {
  data: ProductRoadmapEmbedConfigResponse;
  disabled: boolean;
  onOpen: () => void;
  onEdit: () => void;
  onRemove?: () => void;
}) => {
  const {hostname, pathname} = new URL(data.open_url);
  const provider =
    hostname === 'www.dropbox.com'
      ? t('roadmap_provider_paper')
      : hostname === 'docs.google.com'
        ? t(
            pathname.startsWith('/presentation/')
              ? 'roadmap_provider_slides'
              : 'roadmap_provider_docs'
          )
        : hostname === 'dropbox.atlassian.net'
          ? t('roadmap_provider_confluence')
          : hostname;
  const actionClass = atoms({color: 'Text Subtle'});
  return (
    <Box paddingBottom="12">
      <Box
        borderColor="Border Subtle"
        borderStyle="Solid"
        borderWidth="1"
        borderRadius="Large"
        overflow="hidden"
        width="100%"
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          paddingX="16"
          paddingY="12"
          flexWrap="wrap"
          backgroundColor="Background Subtle"
          borderBottom="Solid"
          borderColor="Border Subtle"
        >
          <Text>
            {t('roadmap')} · <Text color="subtle">{provider}</Text>
          </Text>
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <Button
              className={actionClass}
              variant="borderless"
              size="small"
              withIconStart={<UIIcon src={OpenLine} size="small" />}
              onClick={onOpen}
            >
              <Text size="medium" color="subtle">
                {t('workstream_roadmap_open_new_tab')}
              </Text>
            </Button>
            <Button
              className={actionClass}
              variant="borderless"
              size="small"
              withIconStart={<UIIcon src={EditLine} size="small" />}
              onClick={onEdit}
              disabled={disabled}
            >
              <Text size="medium" color="subtle">
                {t('workstream_product_roadmap_edit_link')}
              </Text>
            </Button>
            {onRemove && (
              <Button
                className={actionClass}
                variant="borderless"
                size="small"
                withIconStart={<UIIcon src={DeleteLine} size="small" />}
                onClick={onRemove}
                disabled={disabled}
              >
                <Text size="medium" color="subtle">
                  {t('remove')}
                </Text>
              </Button>
            )}
          </Box>
        </Box>
        <RoadmapDocumentEmbed data={data} />
        <Box paddingX="16" paddingY="12" borderTop="Solid" borderColor="Border Subtle">
          <Text color="subtle">
            {t('workstream_roadmap_embed_footer', {
              openAction: t('workstream_roadmap_open_new_tab'),
            })}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
